import { render, staticRenderFns } from "./filtrele.vue?vue&type=template&id=08aae498&scoped=true&"
import script from "./filtrele.vue?vue&type=script&lang=js&"
export * from "./filtrele.vue?vue&type=script&lang=js&"
import style0 from "./filtrele.vue?vue&type=style&index=0&id=08aae498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aae498",
  null
  
)

export default component.exports